import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import createPersistedState from 'vuex-persistedstate';

const STORE_KEY = 'RSLT';
const STORE_VERSION = 15;

Vue.use(Vuex);

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.(js|ts)$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
	// set './app.js' => 'app'
	const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
	const value = modulesFiles(modulePath);
	modules[moduleName] = value.default;
	return modules;
}, {});

const persistedState = createPersistedState({
	key: STORE_KEY + '-' + STORE_VERSION,
	paths: [
		'recipients',
		'invoices.rightPanelCollapsed',
		'risolto.selectedParticipantStore',
		'risolto.selectedLegalEntityStore'
	]
});

/*
Run a commit when a specific mutation happens
This is done to avoid multiple uses of watchers in different components
Pattern is 'mutation to watch': [
	['mutation to commit', payload],
	['mutation to commit', payload]
]
*/
const resetRules = {
	'risolto/SET_SELECTED_PARTICIPANT': [
		['messages/SET_FILTER_ASSIGNEE', []],
		['disputes/SET_FILTER_ASSIGNEE', null],
		['worklist/SET_WORKLIST_ACTION_REFS', []],
		['actions/CLEAR_ACTIONS', null]
	],
	'risolto/SET_SELECTED_LEGAL_ENTITY': [
		['messages/SET_FILTER_ASSIGNEE', []],
		['disputes/SET_FILTER_ASSIGNEE', null],
		['worklist/SET_WORKLIST_ACTION_REFS', []],
		['actions/CLEAR_ACTIONS', null]
	]
};

const resetOnParticipantOrEntityChange = (store) => {
	store.subscribe(({ type }) => {
		const rules = resetRules[type];
		if (!rules) return;

		for (const [mutation, payload] of rules) {
			store.commit(mutation, payload);
		}
	});
};

const store = new Vuex.Store({
	modules,
	getters,
	plugins: [
		persistedState,
		resetOnParticipantOrEntityChange
	]
});

export default store;
